export enum Vendor {
  NIRVANA = 'NIRVANA',
  CORGI = 'CORGI',
  COVERWHALE = 'COVERWHALE',
  ROCKLAKE = 'ROCKLAKE',
  GEICO = 'GEICO',
  RYAN_SPECIALTY = 'RYAN_SPECIALTY',
  AMWINS = 'AMWINS',
  PROGRESSIVE = 'PROGRESSIVE',
}

export enum InsuranceIndicationStatus {
  PENDING = 'PENDING',
  GENERATED = 'GENERATED',
  DECLINED = 'DECLINED',
  ERROR = 'ERROR',
  UNAVAILABLE = 'UNAVAILABLE',
  /** Superseded by a later re-quote. Still served, and still checkoutable, when it priced. */
  CANCELED = 'CANCELED',
}

/** Which record a staff-entered offer lands as. A quote also creates the indication it hangs off. */
export enum InsuranceOfferKind {
  INDICATION = 'indication',
  QUOTE = 'quote',
}

export enum InsuranceQuoteStatus {
  PENDING = 'PENDING',
  QUOTED = 'QUOTED',
  REQUEST_TO_BIND = 'REQUEST_TO_BIND',
  BOUND = 'BOUND',
  DECLINED = 'DECLINED',
  ERROR = 'ERROR',
}

/** A premium shown as a range, in whole dollars, because the figure behind it is only an estimate. */
export interface PremiumRange {
  low: number
  high: number
}

export interface InsuranceCoverage {
  id: string
  coverageType: string
  vendorCoverageType: string
  limit: number | null
  deductible: number | null
  /** Set only when physical damage has a comprehensive deductible of its own. */
  comprehensiveDeductible?: number | null
  /** null when the carrier prices the policy as one total (Corgi v2) — a $0 reads as free cover. */
  premium: number | null
  /** Shown in place of the premium: a Corgi prequote's auto liability. Optional for deploy skew. */
  premiumRange?: PremiumRange | null
  premiumPerUnit: number
  label: string
  isPricePerTruck: boolean
  /** The carrier's number for the policy this line is written on; Corgi issues one per line. Optional for deploy skew. */
  vendorPolicyId?: string
  /** The Corgi portal page for that policy, for staff; empty for other carriers. Optional for deploy skew. */
  vendorPolicyUrl?: string
  /** The date this coverage alone was canceled as of, on a policy. Optional for deploy skew. */
  dateCanceled?: string | null
  cancellationStatus?: CoverageCancellationStatus | null
}

export enum CoverageCancellationStatus {
  CANCELING = 'CANCELING',
  CANCELED = 'CANCELED',
}

export interface InsuranceOneTimeFee {
  id: string
  label: string
  amount: number
}
